import { render, staticRenderFns } from "./AccountingAjout.vue?vue&type=template&id=4820b155&"
import script from "./AccountingAjout.vue?vue&type=script&lang=js&"
export * from "./AccountingAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports